import { useTranslation } from 'react-i18next';

import { useFormatPeriod } from '@/hooks/use-format-period';
import { isEventLive, resolveEventTimeInfo } from '@/utils/event-time';

import { useSbkBetSlipStore } from './use-sbk-betslip-store';

/**
 * Returns the time info for an event and whether it's live.
 * Live events: period + clock (e.g., "1st, 8:37"), or "LIVE" when no clock data.
 * Pre-match events: formatted start time (e.g., "Today, 8:00 PM")
 */
export const useEventTimeInfo = (eventId: string) => {
    const { t } = useTranslation('event_time');
    const event = useSbkBetSlipStore(state => state.events[eventId]);

    const periodTime = useFormatPeriod({
        event,
        periodName: event?.event_details?.period_name,
        gameClock: event?.event_details?.game_clock,
        sportSpecific: event?.event_details?.sport_specific,
    });

    if (!event) {
        return { timeInfo: '', isLive: false };
    }

    const isLive = isEventLive(event);
    const timeInfo = resolveEventTimeInfo({ periodTime, isLive, startTime: event.start_time, liveLabel: t('live') });

    return {
        timeInfo,
        isLive,
    };
};
